import styled from '@emotion/styled'

export const StyleAlertTitle = styled.h3`
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  margin-top: 30px;
  color: ${(props: any) => props.theme.colors.primary};
`

export const StyleAlertDescription = styled.p`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors.iconPrimary};
  text-align: center;
  font-weight: 400;
  line-height: 22px;
  margin-top: 15px;
`
